import {addParsedDateToJob, JobRead, JobResults} from "../schemas";
import {apiFetch} from "./client";

export async function getActiveJobs(groupId: string): Promise<JobRead[]> {
    const resp = await apiFetch<JobResults>("/jobs/get_active_group_jobs", {
        params: {group_id: groupId},
    });
    return resp.jobs.map(addParsedDateToJob);
}

export async function dismissJobWarnings(jobId: number): Promise<void> {
    await apiFetch(`/jobs/dismiss_warnings/${jobId}`, {method: "POST"});
}
